"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _field = _interopRequireDefault(require("./field"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FormField = /*#__PURE__*/function (_Field) {
  (0, _inherits2.default)(FormField, _Field);

  var _super = _createSuper(FormField);

  function FormField() {
    var _this;

    (0, _classCallCheck2.default)(this, FormField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'FormField');
    return _this;
  }

  (0, _createClass2.default)(FormField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(FormField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'form',
            component: 'Field',
            required: true
          }, {
            name: 'pristine',
            component: 'BooleanField'
          }, {
            name: 'elevate',
            component: 'BooleanField'
          }]
        }
      });

      this._listenForLoad();
    }
  }, {
    key: "_listenToForm",
    value: function _listenToForm(form) {
      var _this2 = this;

      this._bubbleUpEvents(form, ['dirty', 'touched']); // We use _set() instead of set() so that a change from the form isn't passed back down to the
      // form


      form.on('value', function () {
        return _this2._set('value', _this2.getValues());
      });
    }
  }, {
    key: "_handleLoadFactory",
    value: function _handleLoadFactory() {
      var _this3 = this;

      return function () {
        // Pass load event down to form
        _this3.get('form').emitLoad();
      };
    }
  }, {
    key: "_listenForLoad",
    value: function _listenForLoad() {
      this.on('load', this._handleLoadFactory());
    }
  }, {
    key: "_setForm",
    value: function _setForm(form) {
      // Clean up any existing form
      var oldForm = this.get('form');

      if (oldForm) {
        oldForm.removeAllListeners();
      } // Note: we will be modifying the form. A previous design cloned the form, but the clone method
      // leads to race conditions such as where the the didCreate event is never fired on a sub field
      // of the cloned field.


      this._set('form', form);

      this._listenToForm(form);
    }
  }, {
    key: "set",
    value: function set(props) {
      var clonedProps = Object.assign({}, props, {
        form: undefined
      });
      (0, _get2.default)((0, _getPrototypeOf2.default)(FormField.prototype), "set", this).call(this, clonedProps);

      if (props.form !== undefined) {
        this._setForm(props.form);
      }

      if (props.err === null) {
        this._setOnForm({
          err: null
        });
      } // Was the form set? It may not have been set yet


      if (this._form) {
        // Set properties on form
        this._setOn(this._form, clonedProps, ['value', 'dirty', 'disabled', 'editable', 'touched', 'pristine', 'useDisplayValue', 'fullWidth']);
      }
    }
  }, {
    key: "getOne",
    value: function getOne(name) {
      var value = this._getFrom(this._form, name, ['dirty', 'disabled', 'editable', 'touched', 'pristine']);

      if (value !== undefined) {
        return value;
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(FormField.prototype), "getOne", this).call(this, name);
    }
  }, {
    key: "validate",
    value: function validate() {
      var form = this.get('form');
      form.validate();

      if (form.hasSetErrors()) {
        // If the form has errors from the last set, e.g. "not an object," then we want only these
        // errors as they are often the root of sub-errors.
        this.setErr(form.getErrs());
      } else {
        (0, _get2.default)((0, _getPrototypeOf2.default)(FormField.prototype), "validate", this).call(this);

        if (!this.hasErr() && form.hasErr()) {
          this.setErr(form.getErrs());
        }
      }
    }
  }, {
    key: "getForm",
    value: function getForm() {
      return this.get('form');
    }
  }, {
    key: "getValues",
    value: function getValues() {
      return this.get('form').get('value');
    }
  }, {
    key: "setValues",
    value: function setValues(values) {
      this.get('form').setValues(values);
    }
  }, {
    key: "getField",
    value: function getField(name) {
      return this.get('form').getField(name);
    }
  }, {
    key: "isBlank",
    value: function isBlank() {
      return this.get('form').isBlank();
    }
  }, {
    key: "_setOnForm",
    value: function _setOnForm(props) {
      this.get('form').set(props);
    }
  }]);
  return FormField;
}(_field.default);

exports.default = FormField;